import React, { useEffect, useState } from "react";

import { Alert, Button, Table } from "react-bootstrap";
import AlertService from "../services/alert.service";
import { ReactComponent as StarIcon } from "../ui/Icons/star-icon.svg";
import { getCommonKeys } from "../utils/alertsUtils";
import AddTrade from "../ui/AddTrade.component";
import TableHead from "../ui/TableHead.component";
import Loader from "../ui/Spinner.component";
import Modal from "../ui/uiElements/Modal.component";
import AlertPopup from "../ui/AlertPopup.component";
import toast from "react-hot-toast";

import { ReactComponent as TradeIcon } from "../ui/Icons/trade.svg";
import PaginationTab from "../ui/uiElements/PaginationTab.component";
import { Link } from "react-router-dom";
import { useSortTable } from "../hooks/useSortTable";

const headerKeys = [
  { lable: "Ticker", name: "ticker", sortable: true },
  { lable: "Type", name: "type", sortable: true },
  { lable: "Open", name: "open", sortable: true },
  { lable: "Close", name: "close", sortable: true },
  { lable: "Date", name: "date", sortable: true },
  { lable: "Volume", name: "volume", sortable: true },
  { lable: "Days", name: "count", sortable: true },
  { lable: "Notes", name: "notes", sortable: false },
];

function Alerts({ query, shortListContent }) {
  const [content, setContent] = useState([]);
  const [tickerCount, setTickerCount] = useState([]);
  const [pagination, setPagination] = useState(null);
  const [page, setPage] = useState(1);
  const [sort, setSort] = useState("date");
  const [order, setOrder] = useState("desc");
  const [timer, setTimer] = useState(null);
  const [commonKeys, setCommonKeys] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [errors, setErrors] = useState(null);

  const itemsPerPage = localStorage.getItem("paginationConfig");
  if (itemsPerPage == null) {
    localStorage.setItem("paginationConfig", 50);
  }

  useEffect(() => {
    if (query) {
      setIsLoading(true);
      AlertService.getAlerts({ sort, order, page, itemsPerPage, query })
        .then(response => {
          setContent(response.alerts);
          setPagination(response.pagination);
          setTickerCount(response.tickerDateCounts);
          setIsLoading(false);
        })
        .catch(err => {
          setErrors({
            alertsError: err.toString() || "Something went wrong, Couldn't fetch Alerts",
          });
          setIsLoading(false);
        });
    }
    if (shortListContent) {
      setContent(shortListContent.alerts);
      setTickerCount(shortListContent.tickerDateCounts);
    }
  }, [query, shortListContent, setContent, page, sort, order, itemsPerPage]);

  useEffect(() => {
    setCommonKeys(getCommonKeys(content));
  }, [content]);

  const [tableData, sortingHandler] = useSortTable(content);
  useEffect(() => {
    if (tableData.length === 0) {
      return;
    } else {
      setContent(tableData);
    }
  }, [tableData]);

  const handleChange = (e, i) => {
    e.preventDefault();
    clearTimeout(timer);
    var notes = e.target.value;
    setContent(prevContent => {
      const newContent = [...prevContent];
      try {
        newContent[i]["notes"] = notes;
        return [...newContent];
      } catch (e) {
        return [...newContent];
      }
    });

    const newTimer = setTimeout(() => {
      processChange(e, i);
    }, 500);

    setTimer(newTimer);
  };

  const processChange = (e, i) => {
    var id = content[i]["_id"];
    var notes = e.target.value;
    AlertService.postNotes(id, notes, i).then(
      response => {
        console.log(response.data);
      },
      error => {
        setContent((error.response && error.response.data) || error.message || error.toString());
      }
    );
  };

  const handleBookmark = async i => {
    setErrors(null);
    var id = content[i]["_id"];

    setContent(prevContent => {
      const updatedContent = [...prevContent];
      updatedContent[i]["isBookmarked"] = !updatedContent[i]["isBookmarked"];
      return [...updatedContent];
    });
    try {
      await AlertService.postStarBookmark(id);
      if (content[i]["isBookmarked"] === true) {
        toast.success("Alert added to shortlist");
      }
      if (content[i]["isBookmarked"] === false) {
        toast.error("Alert Removed from shortlist");
      }
    } catch (error) {
      setErrors({
        shortlistError: error.response?.data || "An error occured, try again later",
      });
      setContent(prevContent => {
        const updatedContent = [...prevContent];
        updatedContent[i]["isBookmarked"] = !updatedContent[i]["isBookmarked"];
        return [...updatedContent];
      });
    }
  };

  if (isLoading) return <Loader />;

  if (errors?.alertsError) return <Alert variant="danger">{errors?.alertsError}</Alert>;

  if (content.length === 0) return <Alert>No data to show</Alert>;


  return (
    <div className="container table-container">
      {errors?.shortlistError ? <Alert variant="danger">{errors?.shortlistError}</Alert> : null}
      {(pagination?.totalItems > itemsPerPage || !shortListContent) && (
        <div className="d-flex justify-content-between align-items-center  w-100">
          <Link
            to={`/charts?data=${encodeURIComponent(
              Array.from(new Set(content.map(item => item.ticker + "+" + item.primaryExch)))
            )}`}
            className="fw-bold"
          >
            Show Charts
          </Link>
          <PaginationTab content={content} page={page} setPage={setPage} pagination={pagination} />
        </div>
      )}
      <header className="jumbotron">
        <Table striped bordered hover responsive>
          <TableHead
            order={order}
            setOrder={setOrder}
            setSort={shortListContent ? sortingHandler : setSort}
            commonKeys={commonKeys}
            headerKeys={headerKeys}
          />

          <tbody>
            {content.map((item, index) => (
              <tr key={index} className="alerts-table-rows">
                {commonKeys.ticker && (
                  <td className=" text-center">
                    <div>
                      <StarIcon
                        style={{
                          fill: `${item.isBookmarked ? "#F0C000" : "none"} `,
                          stroke: `${!item.isBookmarked ? "grey" : "#F0C000"} `,
                          cursor: "pointer",
                          width: "25px",
                          height: "25px",
                        }}
                        onClick={() => handleBookmark(index)}
                      />

                      <Modal>
                        <Modal.Open opens="more-details">
                          <button className="btn fw-bold fs-6 bg-transparent">+</button>
                        </Modal.Open>
                        <Modal.Window name="more-details">
                          <AlertPopup alert={item} />
                        </Modal.Window>
                      </Modal>

                      <a
                        className="pe-1 text-decoration-none fw-bold"
                        href={"https://www.tradingview.com/chart/mq31yJ7K/?symbol=" + item.ticker}
                        target="_blank"
                        rel="noreferrer"
                      >
                        {item.ticker}
                      </a>

                      <span>( {tickerCount[`${item.ticker}_${item.date}`]} )</span>
                      <Modal>
                        <Modal.Open opens="add-trade">
                          <Button size="sm" variant="light">
                            <TradeIcon />
                          </Button>
                        </Modal.Open>
                        <Modal.Window name="add-trade">
                          <AddTrade alert={item} />
                        </Modal.Window>
                      </Modal>
                    </div>
                  </td>
                )}

                {commonKeys.type && <td>{item.type}</td>}
                {commonKeys.open && <td>{item.open}</td>}
                {commonKeys.close && <td>{item.close}</td>}
                {commonKeys.date && <td>{item.date.split("T")[0]}</td>}
                {commonKeys.volume && <td>{item.volume}</td>}
                {commonKeys.count && <td>{item.count}</td>}
                {commonKeys.notes && (
                  <td>
                    <textarea
                      type="textarea"
                      name="textarea"
                      value={item.notes}
                      onChange={event => handleChange(event, index)}
                    />
                  </td>
                )}
              </tr>
            ))}
          </tbody>
        </Table>
      </header>
    </div>
  );
}

export default Alerts;
